import React from 'react'
import { withContentful } from 'components/vendor/Contentful/withContentful'
import { CNF_EMBED_HELPER_SCRIPT_URL_MAP, CONTENTFUL_KEYS, EMBED_PARTNERS, EMBED_PRODUCTS } from 'parameters'
import MultiProductWidget from 'components/vendor/MultiProductWidget/MultiProductWidget'
import ProductPageLayout from './common/ProductPageLayout'
import { ExplorePageReduxProps } from 'types/page'

const PersonalLoansPage = ({ articles, getValue }: ExplorePageReduxProps): JSX.Element => {
	const isCnfEmbedExperience = !!CNF_EMBED_HELPER_SCRIPT_URL_MAP[EMBED_PRODUCTS.LOAN]

	return (
		<ProductPageLayout
			product={EMBED_PRODUCTS.LOAN}
			isCnfEmbedExperience={isCnfEmbedExperience}
			articles={articles}
			title={
				<h1>
					{getValue(CONTENTFUL_KEYS.PRODUCTS.PERSONAL_LOANS.TITLE.FIRST)}{' '}
					<strong>{getValue(CONTENTFUL_KEYS.PRODUCTS.PERSONAL_LOANS.TITLE.SECOND)}</strong>
				</h1>
			}
			description={getValue(CONTENTFUL_KEYS.PRODUCTS.PERSONAL_LOANS.DESCRIPTION)}
		>
			<MultiProductWidget
				versionOverride={getValue({
					KEY: 'embed_override',
					TYPE: 'value'
				})}
				step={'application'}
				product={EMBED_PRODUCTS.LOAN}
				partner={EMBED_PARTNERS.FIONA}
				isCnfEmbedExperience={isCnfEmbedExperience}
			/>
		</ProductPageLayout>
	)
}

export default withContentful(PersonalLoansPage)
